import Vue from "vue"
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
import router from '../router/index.js'
let axios_instance = axios.create({
    transformRequest: [function(data) {
        data = qs.stringify(data);
        return data;
    }],
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'formdata': 1
    }
});
Vue.use(VueAxios, axios_instance);

/**
 * [get description] 发送get请求
 * @param  {[type]} url    [description] 请求地址
 * @param  {[type]} params [description] 请求参数
 * @param {[type]} [isShare] [description] 是否是分享屏
 * @return {[type]}        [description]
 */
Vue.prototype.post = function(url, params, isShare) {
    let self = this;
    let headers, addr, surl;
    url = url;
    params = params;
    return new Promise((resolve, reject) => {
        self.$http.post(url, params).then(response => {
            headers = response.headers;
            if (response.data.code == 500) {
                /*self.$msg({
                    type: 'error',
                    content: response.data.msg,
                    time: 2000,
                });*/
                reject(response.data);
            } else {
                resolve(response.data);
            }
        }, error => {
            reject();
        })
    });
};
/**
 * [get description] get请求
 * @param  {[type]}  url     [description] 请求地址
 * @param  {[type]}  params  [description] 请求参数
 * @param  {Boolean} isShare [description] 是否是分享
 * @return {[type]}          [description]
 */
Vue.prototype.get = function(url, params, isShare) {
    let self = this;
    let headers, addr, surl;
    url = url;
    params = params;
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            //self.hostConfig为undefined
            url: url,
            params: params,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        }).then((response) => {
            headers = response.headers;
            if (response.data.code == 500) {
                self.$msg({
                    type: 'error',
                    content: response.data.msg,
                    time: 2000,
                });
                reject();
            } else {
                resolve(response.data);
            }
        }, (error) => {
            reject();
        });
    });
};